import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonToastService } from 'src/app/all-modules/shared/services/common-toast.service';
import { CommonService } from 'src/app/all-modules/shared/services/common.service';
import { SpinnerService } from 'src/app/all-modules/shared/services/spinner.service';
import { ApiResponse } from 'src/app/all-modules/shared/common-model/common.model';
import { MESSAGE_CATEGORY_CONSTATNS, MESSAGE_CONSTATNS, SO_STATUS_CONSTANTS } from 'src/app/all-modules/shared/constants/constant';
import { soClientSentFeedbackToTeamDTO } from '../model/client-feedback.model';
import { ExposeService } from '../services/expose-service';
import { soClientFeedbackLinkDetails } from '../model/expose.model';

@Component({
    selector: 'app-so-client-feedback',
    templateUrl: './so-client-feedback.component.html',
    styleUrl: './so-client-feedback.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SoClientFeedbackComponent {
  linkUniqueKey = "";
  linkExpired = true;
  note: string = "";
  message: string = "";
  soVersion = "";
  SENT_BACK_BY_CLIENT_KEY = SO_STATUS_CONSTANTS.SENT_BACK_BY_CLIENT_KEY;
  APPROVED_KEY = SO_STATUS_CONSTANTS.APPROVED_KEY;
  NOT_APPROVED_KEY = SO_STATUS_CONSTANTS.NOT_APPROVED_KEY;
  isSuccess = false;
  linkDetails!: soClientFeedbackLinkDetails;
  constructor(private router: Router,
    private spinerService: SpinnerService, private commonToastService: CommonToastService, private route: ActivatedRoute,
    private commonService: CommonService, private spinnerService: SpinnerService, private exposeService: ExposeService) {
    this.route.params.subscribe(params => {
      this.linkUniqueKey = params['id']
    });
  }

  ngOnInit() {
    this.soGetClientFeedback();
  }
  soGetClientFeedback() {
    this.spinnerService.show();
    this.exposeService.soGetClientFeedback(this.linkUniqueKey).subscribe({
      next: (response: soClientFeedbackLinkDetails) => {
        this.linkDetails = response;
        this.spinnerService.hide();
        if (this.commonService.isNotNULLEmptyUndefind(response)) {
          this.message = response.message;
          this.soVersion = response.data;
          if (response.success === false) {
            this.linkExpired = true;
          } else {
            this.linkExpired = false;
          }
        } else {
          this.linkExpired = true;
        }
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        }
      }
    });
  }
  sendFeedback(statusKey: string) {
    if (statusKey !== this.APPROVED_KEY) {
      if (!this.commonService.isNotNULLEmptyUndefind(this.note)) {
        this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.WARNING, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.NOTE_REQUIRED);
        return;
      }
    }
    let feedbakc: soClientSentFeedbackToTeamDTO = {
      linkUniqueKey: this.linkUniqueKey,
      note: this.note,
      statusKey: statusKey
    }
    this.spinnerService.show();
    this.exposeService.soClientSendFeedbackToTeam(feedbakc).subscribe({
      next: (res: ApiResponse) => {
        if (res.success === true) {
          this.isSuccess = true;
        } else {
          this.isSuccess = false;
        }
        this.spinnerService.hide();
        this.commonToastService.showToasterMessage(res.msgCategoryKey, res.msgCategoryTitle, res.message);
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        }
      }
    });
  }
}
